import { Component, Input } from '@angular/core';
import { FIELD_ERRORS } from './models';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../icon-v2/icon.component";
import * as i3 from "@ngx-translate/core";
const _c0 = a0 => ({
  variable: a0
});
const _c1 = (a0, a1) => ({
  variable: a0,
  variable2: a1
});
const _c2 = a0 => ({
  domain: a0
});
function FieldErrorComponent_div_0_ng_container_1_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FieldErrorComponent_div_0_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FieldErrorComponent_div_0_ng_container_1_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const error_r1 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    const icon_r3 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.withIcon)("ngIfElse", icon_r3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 3, error_r1.value), " ");
  }
}
function FieldErrorComponent_div_0_ng_container_1_ng_container_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FieldErrorComponent_div_0_ng_container_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FieldErrorComponent_div_0_ng_container_1_ng_container_2_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const error_r1 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    const icon_r3 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.withIcon)("ngIfElse", icon_r3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(4, 3, ctx_r1.FIELD_ERRORS[error_r1.key.toUpperCase()], i0.ɵɵpureFunction1(6, _c0, ctx_r1.fieldName)), " ");
  }
}
function FieldErrorComponent_div_0_ng_container_1_ng_container_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FieldErrorComponent_div_0_ng_container_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FieldErrorComponent_div_0_ng_container_1_ng_container_3_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const error_r1 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    const icon_r3 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.withIcon)("ngIfElse", icon_r3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(4, 3, ctx_r1.FIELD_ERRORS[error_r1.key.toUpperCase()], i0.ɵɵpureFunction2(6, _c1, ctx_r1.fieldName, error_r1.value["requiredLength"])), " ");
  }
}
function FieldErrorComponent_div_0_ng_container_1_ng_container_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FieldErrorComponent_div_0_ng_container_1_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FieldErrorComponent_div_0_ng_container_1_ng_container_4_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const error_r1 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    const icon_r3 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.withIcon)("ngIfElse", icon_r3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(4, 3, ctx_r1.FIELD_ERRORS[error_r1.key.toUpperCase()], i0.ɵɵpureFunction1(6, _c0, ctx_r1.fieldName)), " ");
  }
}
function FieldErrorComponent_div_0_ng_container_1_ng_container_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FieldErrorComponent_div_0_ng_container_1_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FieldErrorComponent_div_0_ng_container_1_ng_container_5_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const error_r1 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    const icon_r3 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.withIcon)("ngIfElse", icon_r3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(4, 3, ctx_r1.FIELD_ERRORS[error_r1.key.toUpperCase()], i0.ɵɵpureFunction1(6, _c2, ctx_r1.fieldValue.split("@").reverse()[0])), " ");
  }
}
function FieldErrorComponent_div_0_ng_container_1_ng_container_6_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FieldErrorComponent_div_0_ng_container_1_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FieldErrorComponent_div_0_ng_container_1_ng_container_6_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const error_r1 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    const icon_r3 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.withIcon)("ngIfElse", icon_r3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 3, ctx_r1.FIELD_ERRORS[error_r1.key.toUpperCase()]), " ");
  }
}
function FieldErrorComponent_div_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FieldErrorComponent_div_0_ng_container_1_ng_container_1_Template, 5, 5, "ng-container", 3)(2, FieldErrorComponent_div_0_ng_container_1_ng_container_2_Template, 5, 8, "ng-container", 3)(3, FieldErrorComponent_div_0_ng_container_1_ng_container_3_Template, 5, 9, "ng-container", 3)(4, FieldErrorComponent_div_0_ng_container_1_ng_container_4_Template, 5, 8, "ng-container", 3)(5, FieldErrorComponent_div_0_ng_container_1_ng_container_5_Template, 5, 8, "ng-container", 3)(6, FieldErrorComponent_div_0_ng_container_1_ng_container_6_Template, 5, 5, "ng-container", 3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const error_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", error_r1.key === "custom");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", error_r1.key === "required" && (ctx_r1.submitted || ctx_r1.showRequiredErrorWithoutSubmit));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", error_r1.key === "minlength" || error_r1.key === "maxlength");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", error_r1.key === "email" || error_r1.key === "pattern");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", error_r1.key === "employee");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", error_r1.key === "captcha");
  }
}
function FieldErrorComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, FieldErrorComponent_div_0_ng_container_1_Template, 7, 6, "ng-container", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const error_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", error_r1.value);
  }
}
function FieldErrorComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelement(1, "geaui-icon-v2", 5);
    i0.ɵɵelementEnd();
  }
}
export class FieldErrorComponent {
  // the types are not available - does anyone have a clue how to fix this?
  errors = null;
  withIcon = true;
  fieldName = '';
  fieldValue = '';
  submitted = false;
  showRequiredErrorWithoutSubmit = false;
  touched = false;
  FIELD_ERRORS = FIELD_ERRORS;
  static ɵfac = function FieldErrorComponent_Factory(t) {
    return new (t || FieldErrorComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: FieldErrorComponent,
    selectors: [["geaui-field-error"]],
    inputs: {
      errors: "errors",
      withIcon: "withIcon",
      fieldName: "fieldName",
      fieldValue: "fieldValue",
      submitted: "submitted",
      showRequiredErrorWithoutSubmit: "showRequiredErrorWithoutSubmit",
      touched: "touched"
    },
    decls: 4,
    vars: 3,
    consts: [["icon", ""], ["class", "gea-field-error-container gea-font-heading-14", 4, "ngFor", "ngForOf"], [1, "gea-field-error-container", "gea-font-heading-14"], [4, "ngIf"], [4, "ngIf", "ngIfElse"], ["file", "16px_error-icon"]],
    template: function FieldErrorComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, FieldErrorComponent_div_0_Template, 2, 1, "div", 1);
        i0.ɵɵpipe(1, "keyvalue");
        i0.ɵɵtemplate(2, FieldErrorComponent_ng_template_2_Template, 2, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(1, 1, ctx.errors));
      }
    },
    dependencies: [i1.NgForOf, i1.NgIf, i2.IconComponent, i1.KeyValuePipe, i3.TranslatePipe],
    styles: [".gea-field-error-container[_ngcontent-%COMP%]{display:flex;align-items:center;gap:8px;color:var(--geaui-tertiary-red-80);margin-top:4px}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FieldErrorComponent, [{
    type: Component,
    args: [{
      selector: 'geaui-field-error',
      template: "<div class=\"gea-field-error-container gea-font-heading-14\" *ngFor=\"let error of errors | keyvalue\">\n  <ng-container *ngIf=\"error.value\">\n    <ng-container *ngIf=\"error.key === 'custom'\">\n      <ng-container *ngIf=\"!withIcon; else icon\"></ng-container>\n      <span>\n        {{ error.value | translate }}\n      </span>\n    </ng-container>\n    <ng-container *ngIf=\"error.key === 'required' && (submitted || showRequiredErrorWithoutSubmit)\">\n      <ng-container *ngIf=\"!withIcon; else icon\"></ng-container>\n      <span>\n        {{ FIELD_ERRORS[error.key.toUpperCase()] | translate: { variable: fieldName } }}\n      </span>\n    </ng-container>\n    <ng-container *ngIf=\"error.key === 'minlength' || error.key === 'maxlength'\">\n      <ng-container *ngIf=\"!withIcon; else icon\"></ng-container>\n      <span>\n        {{ FIELD_ERRORS[error.key.toUpperCase()] | translate: { variable: fieldName, variable2: error.value['requiredLength'] } }}\n      </span>\n    </ng-container>\n    <ng-container *ngIf=\"error.key === 'email' || error.key === 'pattern'\">\n      <ng-container *ngIf=\"!withIcon; else icon\"></ng-container>\n      <span>\n        {{ FIELD_ERRORS[error.key.toUpperCase()] | translate: { variable: fieldName } }}\n      </span>\n    </ng-container>\n    <ng-container *ngIf=\"error.key === 'employee'\">\n      <ng-container *ngIf=\"!withIcon; else icon\"></ng-container>\n      <span>\n        {{ FIELD_ERRORS[error.key.toUpperCase()] | translate: { domain: fieldValue.split('@').reverse()[0] } }}\n      </span>\n    </ng-container>\n    <ng-container *ngIf=\"error.key === 'captcha'\">\n      <ng-container *ngIf=\"!withIcon; else icon\"></ng-container>\n      <span>\n        {{ FIELD_ERRORS[error.key.toUpperCase()] | translate }}\n      </span>\n    </ng-container>\n  </ng-container>\n</div>\n<ng-template #icon>\n  <span>\n    <geaui-icon-v2 file=\"16px_error-icon\"></geaui-icon-v2>\n  </span>\n</ng-template>\n",
      styles: [".gea-field-error-container{display:flex;align-items:center;gap:8px;color:var(--geaui-tertiary-red-80);margin-top:4px}\n"]
    }]
  }], null, {
    errors: [{
      type: Input
    }],
    withIcon: [{
      type: Input
    }],
    fieldName: [{
      type: Input
    }],
    fieldValue: [{
      type: Input
    }],
    submitted: [{
      type: Input
    }],
    showRequiredErrorWithoutSubmit: [{
      type: Input
    }],
    touched: [{
      type: Input
    }]
  });
})();
